import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as signalR from "@microsoft/signalr";
import { AuthService } from './auth.service';
import { RestService } from './rest.service';
import { NotificationsDto } from '../models/notificationDtos/NotificationsDto';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  public signalrNotifications: NotificationsDto[]=[];
  public hubConnection: signalR.HubConnection
  public signalRConnectionEnabled: boolean = false;

constructor(private authService: AuthService,private restService: RestService) { }

  public startConnection = () => {

  this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(environment.baseUrl + 'signalr/worqua-task-hub', { accessTokenFactory: () => this.authService.getEncryptedToken() })
    .withAutomaticReconnect() // Optional: auto reconnect
    .configureLogging(signalR.LogLevel.Information)
    .build();
  // this.hubConnection = new signalR.HubConnectionBuilder()
  //   .withUrl(environment.baseUrl + 'signalr/worqua-task-hub', { accessTokenFactory: () => this.authService.getEncryptedToken() })
  //   .build();
  this.hubConnection.serverTimeoutInMilliseconds = 120000; 
  this.hubConnection
    .start()
      .then((data) => {
          this.signalRConnectionEnabled = true; 
          console.log('signalR Connection  started');
      })
      .catch(err => {
          this.signalRConnectionEnabled = false;
          console.log('signalr Error while starting connection:  ' + err)
      });
      this.hubConnection.on('ReceiveMessage', (data) =>
      {         
        
        let url = environment.urls.Notification_GET_ALL;
                 this.restService.getWithoutLoader(url).subscribe(res=>{
                  this.signalrNotifications=[];
                  res.result.items.forEach(element => {
                    
                    if(!element.status)
                    {
                     element.statusText='Completed';
                    }
                    
                    this.signalrNotifications.push({
                      icon: 'i-Add-User',
                      title:element.title,
                      badge: element.statusText,
                      text:element.description,
                      time:new Date(element.creationTime),
                      status:element.statusText,
                      link: element.link,
                      isRead:element.isRead,
                      id:element.id,
                      sourceId:element.sourceId,
                      sourceType:element.sourceType,
                      taskGroupId:element.taskGroupId               
                    });

                  });

                 });

          console.log('From signalR- message received ' + data);
      });

      this.hubConnection.on('SmartOfficeGroupMessage', (data) =>
      {         
        
        let url = environment.urls.Notification_GET_ALL;
                 this.restService.getWithoutLoader(url).subscribe(res=>{
                  this.signalrNotifications=[];
                  
                  res.result.items.forEach(element => {
                    if(!element.status)
                    {
                     element.statusText='Completed';
                    }
                    this.signalrNotifications.push({
                      icon: 'i-Add-User',
                      title:element.title,
                      badge: element.statusText,
                      text:element.description,
                      time:new Date(element.creationTime),
                      status:element.statusText,
                      link: element.link,
                      isRead:element.isRead,
                      sourceId:element.sourceId,
                      sourceType:element.sourceType,                 
                      id:element.id,
                      taskGroupId:element.taskGroupId 
                    });

                  });

                 });

          console.log('From signalR- message received ' + data);
      });       

}

//   public addDataListener = () => {

//       this.hubConnection.on('transferchartdata', (data) =>
//       {
//           console.log(data);
//       });

//       this.hubConnection.on('ReceiveMessage', (data) =>
//       {
//           console.log('From signalR- message received ' + data);
//       });

//       this.hubConnection.on('SmartOfficeGroupMessage', (data: string) => {
//       });
// }


public addDataListener(eventType: string): Observable<any> {
  return new Observable<any>((observer) => {
    this.hubConnection.on(eventType, (data: any) => {
      observer.next(data);
    });
  });
}

}
